import * as React from "react";
import { Remove } from "../Remove";
import { Icon } from "sb-resp-ui";

export class Market extends React.Component<{
    title: string
    market: string
    handler?: (e: React.MouseEvent<HTMLElement>) => void
    isSuspended?: boolean
    suspendedTxt?: string
}, {}> {
    render() {
        return (
            <div className="rj-yourbet__market">
                <div className="rj-yourbet__market-details">
                    <p className="rj-yourbet__market-title">{this.props.title}</p>
                    <p className="rj-yourbet__market-type">{this.props.market}</p>
                </div>

                {this.props.handler && <Remove
                    icon="i-16 i-o-yourbet-trash"
                    datauat="i-o-trash"
                    handler={this.props.handler} />}

                {this.props.isSuspended &&
                    <div className="rj-yourbet__suspended-overlay" onClick={this.props.handler}>
                        <div className="rj-yourbet__suspended-overlay-label">
                            <Icon i="i-o-yourbet-close" />
                            <span className="rj-yourbet__suspended-overlay-text">
                                {this.props.suspendedTxt}
                            </span>
                        </div>
                    </div>
                }
            </div>
        );
    }
}